import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
import { PermissionSetType } from 'api/models';
import { useUserPermissionSetType } from 'hooks/permissions';
import { useNewDashboardEnabled } from 'hooks/use-feature';
import { DashboardWidgetWrapper } from 'routes/route-navigators';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';
const DashboardById = /*#__PURE__*/ lazy(()=>import('./dashboard-by-id').then((m)=>({
            default: m.DashboardById
        })));
const AddWidgetPageV2 = /*#__PURE__*/ lazy(()=>import('./widget-creation-steps-v2/add-widget-v2').then((m)=>({
            default: m.AddWidgetPageV2
        })));
const EditWidgetPageV2 = /*#__PURE__*/ lazy(()=>import('./widget-creation-steps-v2/edit-widget-v2').then((m)=>({
            default: m.EditWidgetPageV2
        })));
const AddWidgetPage = /*#__PURE__*/ lazy(()=>import('./widgets/add-widget').then((m)=>({
            default: m.AddWidgetPage
        })));
const EditWidgetPage = /*#__PURE__*/ lazy(()=>import('./widgets/edit-widget').then((m)=>({
            default: m.EditWidgetPage
        })));
// Component to handle conditional widget rendering
const AddWidgetWrapper = ()=>{
    const isNewDashboardEnabled = useNewDashboardEnabled();
    if (isNewDashboardEnabled) {
        return /*#__PURE__*/ _jsx(AddWidgetPageV2, {});
    }
    return /*#__PURE__*/ _jsx(AddWidgetPage, {});
};
const EditWidgetWrapper = ()=>{
    const isNewDashboardEnabled = useNewDashboardEnabled();
    if (isNewDashboardEnabled) {
        return /*#__PURE__*/ _jsx(EditWidgetPageV2, {});
    }
    return /*#__PURE__*/ _jsx(EditWidgetPage, {});
};
const DashboardPageWrapper = ({ children })=>{
    const currentUserPermissionSetType = useUserPermissionSetType();
    const isAccountAdmin = currentUserPermissionSetType === PermissionSetType.AccountAdmin;
    const isSuperUser = currentUserPermissionSetType === PermissionSetType.SuperUser;
    // @TODO RBAC: Remove this after RBAC is shipped
    const icertisPmAccountRole = currentUserPermissionSetType === PermissionSetType.IcertisPmAccountRole;
    return /*#__PURE__*/ _jsx(SecureRoute, {
        rule: isAccountAdmin || isSuperUser || icertisPmAccountRole ? undefined : 'DASHBOARD:READ',
        children: children
    });
};
export const dashboardRoutes = {
    path: ROUTE_PATHS.DASHBOARDS,
    async lazy () {
        const { DashboardReportPage } = await retryImportInsideRoutesDefinition(()=>import('./dashboard'));
        return {
            element: /*#__PURE__*/ _jsx(DashboardPageWrapper, {
                children: /*#__PURE__*/ _jsx(DashboardReportPage, {})
            })
        };
    },
    children: [
        {
            path: ROUTE_PATHS.DASHBOARD_ID,
            element: /*#__PURE__*/ _jsx(DashboardById, {}),
            caseSensitive: true,
            children: [
                {
                    path: ROUTE_PATHS.DASHBOARD_WIDGETS,
                    element: /*#__PURE__*/ _jsx(DashboardWidgetWrapper, {}),
                    children: [
                        {
                            path: ROUTE_PATHS.NEW_DASHBOARD_WIDGET,
                            element: /*#__PURE__*/ _jsx(AddWidgetWrapper, {}),
                            caseSensitive: true
                        },
                        {
                            path: `${ROUTE_PATHS.DASHBOARD_WIDGETS_ID}/${ROUTE_PATHS.EDIT_DASHBOARD_WIDGET}`,
                            element: /*#__PURE__*/ _jsx(EditWidgetWrapper, {}),
                            caseSensitive: true
                        }
                    ]
                }
            ]
        }
    ]
};
